import { Activity, Syringe, ClipboardList, Droplets, Wind, Calculator, Headset, Home, Stethoscope, Scale, Utensils, GraduationCap, ShieldCheck, FileSignature, ClipboardCheck, BedDouble, MessageSquare, TestTube, ShieldAlert, Microscope, FlaskConical, Beaker, Gauge, TestTubes, FileText, Pill, ClipboardSignature, Wrench, LayoutGrid } from "lucide-react";
import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/BrandLogo";

export const WARDROUNDS_STEPS = [
  { id: 1, label: "Sheet", icon: FileText, path: "/ward-rounds" },
  { id: 2, label: "Rights", icon: ShieldCheck, path: "/ward-rounds" },
  { id: 3, label: "Dose calc", icon: Calculator, path: "/ward-rounds" },
  { id: 4, label: "Route", icon: Pill, path: "/ward-rounds" },
  { id: 5, label: "Sign-off", icon: ClipboardSignature, path: "/ward-rounds" },
];

export const URINALYSIS_STEPS = [
  { id: 1, label: "Appearance", icon: Beaker, path: "/urinalysis" },
  { id: 2, label: "Refractometer", icon: Gauge, path: "/urinalysis" },
  { id: 3, label: "Dipstick", icon: TestTubes, path: "/urinalysis" },
  { id: 4, label: "Sediment", icon: Microscope, path: "/urinalysis" },
  { id: 5, label: "Interpret", icon: Stethoscope, path: "/urinalysis" },
];

export const CLINPATH_STEPS = [
  { id: 1, label: "Handling", icon: TestTube, path: "/clinpath" },
  { id: 2, label: "Quality", icon: ShieldAlert, path: "/clinpath" },
  { id: 3, label: "Haematology", icon: Microscope, path: "/clinpath" },
  { id: 4, label: "Biochemistry", icon: FlaskConical, path: "/clinpath" },
  { id: 5, label: "Action", icon: MessageSquare, path: "/clinpath" },
];

export const ADMISSION_STEPS = [
  { id: 1, label: "Identity", icon: ShieldCheck, path: "/admission" },
  { id: 2, label: "Consent", icon: FileSignature, path: "/admission" },
  { id: 3, label: "Pre-op", icon: ClipboardCheck, path: "/admission" },
  { id: 4, label: "Prepare", icon: BedDouble, path: "/admission" },
  { id: 5, label: "Handover", icon: MessageSquare, path: "/admission" },
];

export const ANAESTHESIA_STEPS = [
  { id: 1, label: "Patient", icon: ClipboardList, path: "/intake" },
  { id: 2, label: "Anaesthetic Plan", icon: Syringe, path: "/plan" },
  { id: 3, label: "Monitor", icon: Activity, path: "/monitor" },
];

export const ANAESTHESIA2_STEPS = [
  { id: 1, label: "Patient", icon: ClipboardList, path: "/intake2" },
  { id: 2, label: "Anaesthetic Plan", icon: Syringe, path: "/plan2" },
  { id: 3, label: "Monitor", icon: Activity, path: "/monitor2" },
];

export const FLUID_STEPS = [
  { id: 1, label: "Fluid Pump", icon: Droplets, path: "/fluid-pump" },
];

export const ANAES_MACHINE_STEPS = [
  { id: 1, label: "Machine setup", icon: Wrench, path: "/anaes-machine" },
  { id: 2, label: "Leak test", icon: TestTube, path: "/anaes-machine" },
];

export const IPPV_STEPS = [
  { id: 1, label: "Patient A · cat", icon: Wind, path: "/ippv" },
  { id: 2, label: "Patient B · dog", icon: Wind, path: "/ippv" },
  { id: 3, label: "Patient C · apnoea", icon: Wind, path: "/ippv" },
];

export const DRUGCALC_STEPS = [
  { id: 1, label: "Drug Volume Calc", icon: Calculator, path: "/drug-calc" },
];

export const TRIAGE_STEPS = [
  { id: 1, label: "Ring-In Triage", icon: Headset, path: "/triage" },
];

export const DENTAL_STEPS = [
  { id: 1, label: "Dental Charting", icon: Stethoscope, path: "/dental" },
];

export const NUTRITION_STEPS = [
  { id: 1, label: "Assess", icon: Scale, path: "/nutrition" },
  { id: 2, label: "Calculate", icon: Calculator, path: "/nutrition" },
  { id: 3, label: "Diet", icon: Utensils, path: "/nutrition" },
  { id: 4, label: "Plan", icon: ClipboardList, path: "/nutrition" },
  { id: 5, label: "Educate", icon: GraduationCap, path: "/nutrition" },
];

export const DRUGSTORAGE_STEPS = [
  { id: 1, label: "Identify", icon: Pill, path: "/drug-storage" },
  { id: 2, label: "Store", icon: ShieldCheck, path: "/drug-storage" },
  { id: 3, label: "S8 register", icon: ClipboardList, path: "/drug-storage" },
];

export const DRUGSTORAGE_STEPS_CHALLENGE = [
  ...DRUGSTORAGE_STEPS,
  { id: 4, label: "Spot the breach", icon: ShieldAlert, path: "/drug-storage" },
];

export const StepNav = ({
  current,
  steps = ANAESTHESIA_STEPS,
  title = "Anaesthesia",
  subtitle = "Veterinary anaesthesia training simulator",
}) => {
  const currentLabel = (steps.find((s) => s.id === current) || {}).label || "";
  return (
    <div className="w-full border-b border-slate-200 bg-white/70 backdrop-blur-sm sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link
          to="/sections"
          className="flex items-center gap-3 group"
          data-testid="brand-logo-home"
        >
          <BrandLogo chip />
          <div className="hidden sm:block border-l border-slate-200 pl-3">
            <div className="text-sm font-semibold tracking-tight text-slate-900 flex items-center gap-1.5">
              {title}
              <Home className="w-3 h-3 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <div className="text-[11px] text-slate-500 -mt-0.5">{subtitle}</div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <ol className="hidden lg:flex items-center gap-2" data-testid="step-nav">
            {steps.map((s, idx) => {
              const active = s.id === current;
              const done = s.id < current;
              const Icon = s.icon;
              return (
                <li key={s.id} className="flex items-center">
                  <div
                    className={`flex items-center gap-2 px-3 py-1.5 rounded-md border text-xs font-medium ${
                      active
                        ? "bg-[#0047AB] text-white border-[#0047AB]"
                        : done
                        ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                        : "bg-white text-slate-500 border-slate-200"
                    }`}
                    data-testid={`step-${s.id}`}
                  >
                    <Icon className="w-3.5 h-3.5" />
                    <span>
                      {s.id}. {s.label}
                    </span>
                  </div>
                  {idx < steps.length - 1 && (
                    <div className="w-6 h-px bg-slate-300 mx-1" />
                  )}
                </li>
              );
            })}
          </ol>
          <Link
            to="/sections"
            data-testid="nav-sections-btn"
            className="flex items-center gap-1.5 px-3 py-2 rounded-md border border-slate-200 bg-white text-xs font-semibold text-slate-600 hover:text-[#0047AB] hover:border-[#0047AB] transition-colors whitespace-nowrap"
          >
            <LayoutGrid className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Simulator sections</span>
            <span className="sm:hidden">Sections</span>
          </Link>
        </div>
      </div>

      {/* mobile step indicator (steps <ol> is lg-only) */}
      {steps.length > 1 && (
        <div className="lg:hidden max-w-6xl mx-auto px-6 pb-3" data-testid="step-nav-mobile">
          <div className="text-[11px] font-semibold text-slate-600 mb-1.5">
            Step {current} of {steps.length}
            <span className="text-slate-400 font-normal"> · {currentLabel}</span>
          </div>
          <div className="flex gap-1" aria-hidden="true">
            {steps.map((s) => (
              <span
                key={s.id}
                data-testid={`step-mobile-${s.id}`}
                className={`h-1.5 flex-1 rounded-full ${
                  s.id < current ? "bg-emerald-400" : s.id === current ? "bg-[#0047AB]" : "bg-slate-200"
                }`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StepNav;
